export const PATH_MAP = {
  'transmissions.TransmissionsIndexPage': '/webinars',
  'courses.CoursesIndexPage': '/cursos',
  'resources.ResourcesIndexPage': '/recursos',
  'news.NewsIndexPage': '/blog',
  'specializations.SpecializationsIndexPage': '/especializaciones',
  Podcast: '/recursos/podcasts',
  Gamification: '/recursos/gamification'
}
